// import React from "react";
import {
  withStyles,
  makeStyles,
  Theme,
  createStyles
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";

export const AutoCompleteForm = withStyles({
  inputRoot: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "green",
      borderWidth: 2
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
      borderWidth: 2
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "purple",
      borderWidth: 2
    }
  },
  input: {}
})(Autocomplete as any);

export const useStylesStatusUpdate = makeStyles((theme: Theme) =>
  createStyles({
    checkLineWrapper: {
      display: "flex",
      alignItems: "center",
      padding: "0px 20px"
    },
    checkErrorWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: 4,
      margin: "0px 20px",
      backgroundColor: "rgba(251, 98, 63, 0.15)"
    },
    errorStatus: {
      fontSize: 12,
      lineHeight: 1.5,
      marginLeft: 10,
      fontWeight: "normal",
      color: "var(--dark-grey-blue)"
    },
    errorContainer: {
      padding: "3px 7px 3px 7px",
      backgroundColor: "#f75676",
      borderRadius: 6,
      marginLeft: 6,
      display: "flex",
      alignItems: "center"
    },
    tableWrapper: {
      maxWidth: "790px",
      maxHeight: "370px",
      overflowY: "auto",
      borderBottom: "1px solid #ced2e5"
    },
    input: {
      padding: 0
    },
    inputValueInfo: {
      borderRadius: "4px",
      padding: "13px 0px 13px 0px"
    },
    infoText: {
      fontFamily: "OpenSans",
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 1.5,
      letterSpacing: "normal",
      color: "var(--dark-grey-blue)"
    },
    infoWrapper: {
      // display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: 4,
      margin: "0px 20px",
      backgroundColor: "#e9fafd"
    },
    inputButton: {
      borderRadius: "4px",
      boxShadow: "0 3px 4px 0 rgba(0, 0, 0, 0.14)",
      border: "solid 1px #ececec",
      backgroundColor: "#ffffff !important",
      margin: "10px 6px",
      fontSize: "13px",
      fontWeight: 600,
      lineHeight: "1.23",
      color: "var(--dark-grey-blue) !important",
      "&:hover": {
        backgroundColor: "#ffffff"
      }
    },
    disabledButton: {
      boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.22)",
      backgroundColor: "#ffffff",
      border: "solid 1px #ececec",
      color: "#32325d",
      "&:hover": {
        backgroundColor: "#ffffff !important"
      }
    },
    table: {
      tableLayout: "fixed",
      maxWidth: "800px",
      maxHeight: "600px"
    },
    tableHeaderStyle: {
      color: "var(--dark-grey-blue)",
      fontWeight: 600,
      paddingLeft: "20px",
      wordBreak: "break-all"
    },
    circle: {
      width: "28px",
      height: "28px",
      backgroundImage:
        "linear-gradient(139deg, #0fcbef 2%, #1071ee 95%), linear-gradient(to bottom, #d8d8d8, #d8d8d8)",
      borderRadius: "50%"
    },
    nameInitials: {
      display: "inline-block",
      color: "#FFF",
      textAlign: "center",
      lineHeight: "28px",
      fontWeight: "bold",
      fontSize: "12px"
    }
  })
);

export const useAutoCorrectStyles = makeStyles((theme: Theme) => ({
  root: {
    "&.MuiCheckbox-root": {
      color: "rgb(122, 138, 160)",
      paddingLeft: 0,
      paddingRight: 32
    },
    colorSecondary: {
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "#5e72e4 !important"
      }
    }
  },

  inputRoot: {
    '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: "10px 9px !important"
    },
    '&.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      marginTop: "2px !important",
      marginBottom: "2px !important",
      //   paddingTop:"4px !important",
      paddingLeft: "4px !important",
      color: "#32325d !important",
      border: "0px transparent !important"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #5e72e4"
    }
  },
  paper: {
    "&.MuiAutocomplete-paper": {
      borderRadius: 4,
      boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.16)",
      backgroundColor: "#ffffff"
    }
  },
  endAdornment: {
    "&.MuiAutocomplete-endAdornment": {
      marginTop: 4
    }
  },

  option: {
    "&.MuiAutocomplete-option": {
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 2,
      paddingTop: "0px !important",
      paddingLeft: "14px !important",
      paddingBottom: "0px !important",
      height: "auto",
      margin: 0,
      letterSpacing: "normal",
      color: " #32325d",
      "& .MuiSvgIcon-root": {
        height: "16px !important",
        //   width: "30px !important",
        paddingLeft: 14
      }
    },
    '&.MuiAutocomplete-option[data-focus="true"]': {
      fontWeight: 600,
      backgroundColor: "#f6f9fc !important"
    },
    '&.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: " #ffffff"
    }
  }
}));

export const autoCompleteDropdownStyles = makeStyles((theme: Theme) => ({
  paper: {
    "&.MuiAutocomplete-paper": {
      width: "240px",
      borderRadius: 4,
      boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.16)",
      backgroundColor: "#ffffff"
    }
  },
  listbox: {
    padding: "0px",
    "& .MuiListSubheader-root": {
      fontWeight: "600 !important",
      height: "40px",
      fontSize: "12px",
      padding: "0px 10px",
      lineHeight: "auto !important"
    }
  },
  option: {
    "&.MuiAutocomplete-option": {
      fontSize: "12px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: 2,
      padding: "5px 0px 5px 13px !important",
      // height: "auto",
      margin: 0,
      // letterSpacing: "normal",
      color: " #32325d",
      "&.MuiSvgIcon-root": {
        height: "16px !important",
        paddingLeft: 10
      }
    },
    '&.MuiAutocomplete-option[data-focus="true"]': {
      fontWeight: 600,
      backgroundColor: "#f6f9fc !important"
    },
    '&.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: " #ffffff"
    }
  }
}));

export const useAutoCorrectDropdownStyles = makeStyles((theme: Theme) => ({
  root: {
    "&.MuiCheckbox-root": {
      color: "rgb(122, 138, 160)",
      paddingLeft: 0,
      paddingRight: 20
    }
  },
  colorSecondary: {
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#5e72e4 !important"
    }
  }
}));
